import { render, staticRenderFns } from "./hotelPublishControl.vue?vue&type=template&id=bf85eac6&scoped=true"
import script from "./hotelPublishControl.vue?vue&type=script&lang=js"
export * from "./hotelPublishControl.vue?vue&type=script&lang=js"
import style0 from "./hotelPublishControl.vue?vue&type=style&index=0&id=bf85eac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf85eac6",
  null
  
)

export default component.exports